import { isAxiosError } from 'axios'

/**
 * Mensaje legible de un error de la API. Usa el `detail` de DRF o, en un error de
 * validación, los mensajes por campo. Si nginx reemplazó la respuesta por una página
 * HTML (ver docs/WEB_CONFIG.md), cae al mensaje genérico.
 */
export function mensajeDeError(error: unknown, generico = 'Algo salió mal. Intenta de nuevo.'): string {
  if (!isAxiosError(error)) return generico
  if (!error.response) return 'No se pudo contactar al servidor.'
  const data = error.response.data as unknown
  if (data && typeof data === 'object') {
    const { detail } = data as { detail?: unknown }
    if (typeof detail === 'string' && detail) return detail
    const porCampo = Object.values(data as Record<string, unknown>)
      .flat()
      .filter((m): m is string => typeof m === 'string')
    if (porCampo.length) return porCampo.join(' ')
  }
  return generico
}
